import data from "../../data/index.json";
import { Link } from 'react-router-dom';
import React, { useState, useRef, useEffect } from 'react';
import ProjectDetail from './ProjectDetail';

const getYoutubeVideoId = (url) => {
  if (!url) return null;
  
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  
  return (match && match[2].length === 11) ? match[2] : null;
};

export default function MyPortfolio() {
  const [selectedProject, setSelectedProject] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsPerView, setItemsPerView] = useState(3);
  const carouselRef = useRef(null);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  useEffect(() => {
    const updateItemsPerView = () => {
      if (window.innerWidth <= 768) {
        setItemsPerView(1);
      } else if (window.innerWidth <= 1024) {
        setItemsPerView(2);
      } else {
        setItemsPerView(3);
      }
    };

    updateItemsPerView();
    
    window.addEventListener('resize', updateItemsPerView);
    return () => window.removeEventListener('resize', updateItemsPerView);
  }, []);

  const openModal = (project) => {
    setSelectedProject(project);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedProject(null);
    setIsModalOpen(false);
  };

  const handleClick = (item, originalIndex) => {
    if (!isDragging) {
      if (originalIndex === 0 || originalIndex === 1 || originalIndex === 2 || originalIndex === 6 || originalIndex === 9) {
        window.open(item.video, '_blank', 'noopener,noreferrer');
      } else {
        openModal(item);
      }
    }
  };

  const nextSlide = () => {
    setCurrentIndex(prevIndex => {
      const newIndex = prevIndex + 1;
      return newIndex >= data.portfolio.length - itemsPerView + 1 ? 0 : newIndex;
    });
  };

  const prevSlide = () => {
    setCurrentIndex(prevIndex => {
      const newIndex = prevIndex - 1;
      return newIndex < 0 ? data.portfolio.length - itemsPerView : newIndex;
    });
  };

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    const swipeThreshold = 75;
    if (touchStart - touchEnd > swipeThreshold) nextSlide();
    if (touchStart - touchEnd < -swipeThreshold) prevSlide();
  };

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - carouselRef.current.offsetLeft);
    setScrollLeft(carouselRef.current.scrollLeft);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - carouselRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    
    const dragDistance = scrollLeft - walk;
    
    if (Math.abs(dragDistance) > 50) {
      if (dragDistance > 0) {
        nextSlide();
      } else {
        prevSlide();
      }
      setIsDragging(false);
    }
  };

  const getCarouselTransform = () => {
    const itemWidth = 100 / itemsPerView;
    return `translateX(-${itemWidth * currentIndex}%)`;
  };

  return (
    <section className="portfolio--section" id="MyPortfolio">
      <div className="portfolio--container-box">
        <div className="portfolio--container">
          <p className="sub--title">Recent Projects</p>
          <h2 className="skills--section--heading">My Portfolio</h2>
        </div>
        <div>
          <a href="https://github.com/memokr" className="btn btn-github">Visit My GitHub</a>
        </div>
      </div>
      <div className="carousel-container">
        <button 
          onClick={prevSlide} 
          className="carousel-arrow left"
          aria-label="Previous slide"
        >
          &#9664;
        </button>
        <div 
          className="carousel-viewport" 
          ref={carouselRef} 
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
          onMouseMove={handleMouseMove}
        >
          <div 
            className="carousel-inner" 
            style={{ transform: getCarouselTransform() }}
          >
            {data?.portfolio?.map((item, index) => (
              <div 
                key={index} 
                className="portfolio--section--card"
                style={{ width: `${100 / itemsPerView}%` }}
                onClick={() => handleClick(item, index)}
              >
                <div className="card-inner">
                  <img src={item.src} alt={`${item.title} icon`} className="portfolio--app-icon" />
                  <h3 className="portfolio--app-title">{item.title}</h3>
                  {item.hasVideo && <span className="video-indicator">▶ Video</span>}
                </div>
              </div>
            ))}
          </div>
        </div>
        <button 
          onClick={nextSlide} 
          className="carousel-arrow right"
          aria-label="Next slide"
        >
          &#9654;
        </button>
      </div>
      <ProjectDetail 
        project={selectedProject} 
        isOpen={isModalOpen} 
        onClose={closeModal} 
        getYoutubeVideoId={getYoutubeVideoId}
      />
    </section>
  );
}